import { createContext, useContext } from "react";

export interface IShellNavState {
    /**
     * Whether a page should hide its reopen-nav control. Always true below `lg`, where the
     * sidebar never renders, so this is not an "is the sidebar visible" flag.
     */
    isLeftNavOpen: boolean;
    /** Reopen the left nav after the sidebar's own collapse button has closed it. */
    openLeftNav: () => void;
}

/** Provided by the research-preview shell; pages read it through `ShellNavReopenButton` or `useShellNavContext`. */
export const ShellNavContext = createContext<IShellNavState | undefined>(undefined);

/**
 * The research-preview shell's nav state, or `undefined` outside the shell. Check
 * `useShellNavContext() !== undefined`, not the user's opt-in, for "am I in a pane": an opted-in
 * user can still open a route that has no shell.
 */
export const useShellNavContext = () => useContext(ShellNavContext);
